export default __webpack_public_path__ + "static/media/_______.77dd8198.gif";